import { useEffect, useState } from "react";
import icon from "../../../../img/badge.png";
import flag from "../../../../img/flag.png";
import zodiac from "../../../../img/zodiac.png";
import other from "../../../../img/other.png";

import { ColorPicker } from "../ColorPicker/ColorPicker";
import { colorize, flags, others } from "./iconsBadge";

export function CustomBadgePopup(props) {
  const [isOpenPopup, setIsOpenPopup] = useState(false);
  const searchParams = new URLSearchParams(document.location.search);
  const tabs = ["Select  image", "Choose  a colour", "Edit  text"];
  const tabs2 = [
    "Select  image",
    "Choose  a colour",
    "Icon colour",
    "Edit  text",
  ];
  const [fontSize, setFontSize] = useState("8px");
  const tabsImage = [
    { tab: "Flags", icon: flag },
    { tab: "Other", icon: other },
    { tab: "Colorize", icon: zodiac },
  ];

  const [activeTab, setActiveTab] = useState(1);
  const [activeImageTab, setActiveImageTab] = useState(1);
  const [customBadge, setCustomBadge] = useState({
    hasBadge: "false",
    icon: "null",
    text: "null",
    background: "transparent",
    textColor: "black",
    rotate: "false",
    forbiddenRotate: "false",
    font: "CharlesWright Bold",
    colorIcon: "black",
  });
  const onHandlerUpdateBackground = (color) => {
    setCustomBadge((prevState) => ({
      ...prevState,
      background: color,
    }));
  };
  const onHandlerUpdateColorIcon = (color) => {
    setCustomBadge((prevState) => ({
      ...prevState,
      colorIcon: color,
    }));
  };
  const onHandlerUpdateColor = (color) => {
    setCustomBadge((prevState) => ({
      ...prevState,
      textColor: color,
    }));
  };
  const updateCustomBadge = (value) => {
    setCustomBadge((prevState) => ({
      ...prevState,
      ...value,
    }));
  };

  const buildCustomBadge = () => {
    if (customBadge.icon !== "null" || customBadge.text !== "null") {
      if (props.position === "Left") {
        props.updateChoosedOptions({
          hasCustomBadgeLeft: "true",
          badgeColorLeft: customBadge.background,
          customBadgeTextLeft: customBadge.text,
          customBadgeImageLeft: customBadge.icon,
          customBadgeTextColorLeft: customBadge.textColor,
          customBadgeRotationLeft: customBadge.rotate,
          customBadgeFontLeft: customBadge.font,
          badgeLeft: "null",
          customBadgeColorizeLeft: customBadge.colorize,
          customBadgeIconColorLeft: customBadge.colorIcon,
        });
        const elements = document.querySelectorAll(".badge-left .colorize");

        if (elements.length > 0 && customBadge?.colorIcon) {
          elements.forEach((path) => {
            path.setAttribute("fill", customBadge.colorIcon);
          });
        }
      } else {
        props.updateChoosedOptions({
          hasCustomBadgeRight: "true",
          badgeColorRight: customBadge.background,
          customBadgeTextRight: customBadge.text,
          customBadgeImageRight: customBadge.icon,
          customBadgeTextColorRight: customBadge.textColor,
          customBadgeRotationRight: customBadge.rotate,
          customBadgeFontRight: customBadge.font,
          badgeRight: "null",
          customBadgeColorizeRight: customBadge.colorize,
          customBadgeIconColorRight: customBadge.colorIcon,
        });
        if (props.choosedOptions.showBSAU === "true") {
          props.openModal({
            isValid: false,
            typePlate: "bsau",
          });
          props.updateChoosedOptions({
            showBSAU: false,
          });
        }
        const elements = document.querySelectorAll(".badge-right .colorize");

        if (elements.length > 0 && customBadge?.colorIcon) {
          elements.forEach((path) => {
            path.setAttribute("fill", customBadge.colorIcon);
          });
        }
      }

      props.closePopup(null);
    } else {
      props.closePopup(null);
    }
  };
  useEffect(() => {

    props.position === "Left"
      ? setCustomBadge((prevState) => ({
          ...prevState,
          hasBadge:
            searchParams.get("hasCustomBadgeLeft") ??
            props.choosedOptions.hasCustomBadgeLeft,
          icon:
            searchParams.get("customBadgeImageLeft") ??
            props.choosedOptions.customBadgeImageLeft,
          text:
            searchParams.get("customBadgeTextLeft") ??
            props.choosedOptions.customBadgeTextLeft,
          background:
            searchParams.get("badgeColorLeft") ??
            props.choosedOptions.badgeColorLeft,
          textColor:
            searchParams.get("customBadgeTextColorLeft") ??
            props.choosedOptions.customBadgeTextColorLeft,
          rotate:
            searchParams.get("customBadgeRotationLeft") ??
            props.choosedOptions.customBadgeRotationLeft,
          colorize:
            searchParams.get("customBadgeColorizeLeft") ??
            props.choosedOptions.customBadgeColorizeLeft,
          colorIcon:
            searchParams.get("customBadgeIconColorLeft") ??
            props.choosedOptions.customBadgeIconColorLeft,
        }))
      : setCustomBadge((prevState) => ({
          ...prevState,
          hasBadge:
            searchParams.get("hasCustomBadgeRight") ??
            props.choosedOptions.hasCustomBadgeRight,
          icon:
            searchParams.get("customBadgeImageRight") ??
            props.choosedOptions.customBadgeImageRight,
          text:
            searchParams.get("customBadgeTextRight") ??
            props.choosedOptions.customBadgeTextRight,
          background:
            searchParams.get("badgeColorRight") ??
            props.choosedOptions.badgeColorRight,
          textColor:
            searchParams.get("customBadgeTextColorRight") ??
            props.choosedOptions.customBadgeTextColorRight,
          rotate:
            searchParams.get("customBadgeRotationRight") ??
            props.choosedOptions.customBadgeRotationRight,
          colorize:
            searchParams.get("customBadgeColorizeRight") ??
            props.choosedOptions.customBadgeColorizeRight,
          colorIcon:
            searchParams.get("customBadgeIconColorRight") ??
            props.choosedOptions.customBadgeIconColorRight,
        }));
  }, []);
  useEffect(() => {
    const elementsLeft = document.querySelectorAll(".badge-left .colorize");
    const elementsRight = document.querySelectorAll(".badge-right .colorize");
    const previewWidth =
      document.querySelector(".option-popup__preview").clientWidth - 12;
    if (customBadge.text) {
      const updateSize = (previewWidth / customBadge.text.length) * 1.4;
      updateSize > 8 ? setFontSize(updateSize + "px") : setFontSize("8px");
    }
    if (elementsLeft.length > 0 && customBadge?.colorIcon) {
        elementsLeft.forEach((path) => {
        path.setAttribute("fill", customBadge.colorIcon);
      });
    }

    if (elementsRight.length > 0 && customBadge?.colorIcon) {
        elementsRight.forEach((path) => {
        path.setAttribute("fill", customBadge.colorIcon);
      });
    }
  }, [customBadge]);



  const copyStyling = () => {
    props.position === "Left"
      ? setCustomBadge({
          hasBadge: "true",
          icon: props.choosedOptions.customBadgeImageRight,
          text: props.choosedOptions.customBadgeTextRight,
          background: props.choosedOptions.badgeColorRight,
          textColor: props.choosedOptions.customBadgeTextColorRight,
          rotate: props.choosedOptions.customBadgeRotationRight,
          forbiddenRotate: "false",
          font: props.choosedOptions.customBadgeFontRight,
          colorize: props.choosedOptions.customBadgeColorizeRight,
          colorIcon: props.choosedOptions.customBadgeIconColorRight,
        })
      : setCustomBadge({
          hasBadge: "true",
          icon: props.choosedOptions.customBadgeImageLeft,
          text: props.choosedOptions.customBadgeTextLeft,
          background: props.choosedOptions.badgeColorLeft,
          textColor: props.choosedOptions.customBadgeTextColorLeft,
          rotate: props.choosedOptions.customBadgeRotationLeft,
          forbiddenRotate: "false",
          font: props.choosedOptions.customBadgeFontLeft,
          colorize: props.choosedOptions.customBadgeColorizeLeft,
          colorIcon: props.choosedOptions.customBadgeIconColorLeft,
        });
  };

  return (
    <>
      <div className="option-popup__title flex items-center">
        <figure className="option-popup__icon">
          <img src={icon} alt="size icon" />
        </figure>
        <h4>Build Custom Badge</h4>
      </div>
      <div className="flex justify-between option-popup__tabs">
        {customBadge.colorize === "true" &&
          tabs2.map((item, index) => {
            if (
              (item === "Icon colour" && customBadge.colorize === "true") ||
              item !== "Icon colour"
            ) {
              return (
                <div
                  className={
                    (index + 1 <= activeTab && "option-popup__tab--active") +
                    " option-popup__tab"
                  }
                  onClick={() => setActiveTab(index + 1)}
                >
                  <div className="option-popup__tab-number flex justify-center items-center">
                    {index + 1}
                  </div>
                  <p>{item}</p>
                </div>
              );
            }
          })}
        {customBadge.colorize === "false" &&
          tabs.map((item, index) => {
            if (
              (item === "Icon colour" && customBadge.colorize === "true") ||
              item !== "Icon colour"
            ) {
              return (
                <div
                  className={
                    (index + 1 <= activeTab && "option-popup__tab--active") +
                    " option-popup__tab"
                  }
                  onClick={() => setActiveTab(index + 1)}
                >
                  <div className="option-popup__tab-number flex justify-center items-center">
                    {index + 1}
                  </div>
                  <p>{item}</p>
                </div>
              );
            }
          })}
      </div>
      {activeTab === 1 && (
        <div className="option-popup__choose-image">
          <div className="flex option-popup__image-tabs">
            {tabsImage.map((item, index) => {
              return (
                <div
                  className={
                    (index + 1 === activeImageTab &&
                      "option-popup__image-tab--active") +
                    " option-popup__image-tab flex flex-col justify-center items-center"
                  }
                  onClick={() => setActiveImageTab(index + 1)}
                >
                  <div className="option-popup__tab-icon flex  justify-center items-center">
                    <img src={item.icon} alt="tab icon" />
                  </div>
                  <p>{item.tab}</p>
                </div>
              );
            })}
          </div>
          <div className="option-popup__image-contents">
            {activeImageTab === 1 && (
              <div className="option-popup__image-content grid">
                {flags.map((flag) => {
                  return (
                    <div
                      className={
                        (flag.svg === customBadge.icon &&
                          "option-popup__image--active") +
                        " option-popup__image"
                      }
                      onClick={() =>
                        flag.rotate === true
                          ? updateCustomBadge({
                              icon: flag.svg,
                              text: flag.name,
                              forbiddenRotate: "false",
                              colorize: "false",
                            })
                          : updateCustomBadge({
                              icon: flag.svg,
                              text: flag.name,
                              rotate: "false",
                              forbiddenRotate: "true",
                              colorize: "false",
                            })
                      }
                    >
                      <div className="option-popup__icon-tab">
                        <img
                          width="284"
                          height="168"
                          src={require(`../../../../${flag.svg}`)}
                          alt="icon"
                        />
                      </div>
                      <p>{flag.name}</p>
                    </div>
                  );
                })}
              </div>
            )}
            {activeImageTab === 2 && (
              <div className="option-popup__image-content grid">
                {others.map((other) => {
                  return (
                    <div
                      className={
                        (other.svg === customBadge.icon &&
                          "option-popup__image--active") +
                        " option-popup__image"
                      }
                      onClick={() =>
                        other.rotate === true
                          ? updateCustomBadge({
                              icon: other.svg,
                              text: other.name,
                              forbiddenRotate: "false",
                              colorize: "false",
                            })
                          : updateCustomBadge({
                              icon: other.svg,
                              text: other.name,
                              rotate: "false",
                              forbiddenRotate: "true",
                              colorize: "false",
                            })
                      }
                    >
                      <div className="option-popup__icon-tab">
                        <img
                          width="284"
                          height="168"
                          src={require(`../../../../${other.svg}`)}
                          alt="icon"
                        />
                      </div>
                      <p>{other.name}</p>
                    </div>
                  );
                })}
              </div>
            )}
            {activeImageTab === 3 && (
              <div className="option-popup__image-content grid">
                {colorize.map((colorize) => {
                  return (
                    <div
                      className={
                        (colorize.svg === customBadge.icon &&
                          "option-popup__image--active") +
                        " option-popup__image"
                      }
                      onClick={() =>
                        colorize.rotate === true
                          ? updateCustomBadge({
                              icon: colorize.id,
                              text: colorize.name,
                              forbiddenRotate: "false",
                              colorize: "true",
                            })
                          : updateCustomBadge({
                              icon: colorize.id,
                              text: colorize.name,
                              rotate: "false",
                              forbiddenRotate: "true",
                              colorize: "true",
                            })
                      }
                    >
                      <div
                        className="option-popup__icon-tab"
                        dangerouslySetInnerHTML={{ __html: colorize.svg }}
                      ></div>
                      <p>{colorize.name}</p>
                    </div>
                  );
                })}
              </div>
            )}
          </div>
        </div>
      )}
      {activeTab === 2 && (
        <div className="option-popup__background">
          <p>Badge Background Colour</p>
          <ColorPicker
            color={customBadge.background}
            updateColor={onHandlerUpdateBackground}
          ></ColorPicker>
        </div>
      )}
      {activeTab === 3 && customBadge.colorize === "true" && (
        <div className="option-popup__background">
          <p>Icon Colour</p>
          <ColorPicker
            color={customBadge.colorIcon}
            updateColor={onHandlerUpdateColorIcon}
          ></ColorPicker>
        </div>
      )}
      {((activeTab === 4 && customBadge.colorize === "true") ||
        (activeTab === 3 && customBadge.colorize === "false")) && (
        <div className="option-popup__text-and-color">
          <div className="option-popup__input-text">
            <label for="slogan">Badge Text </label>
            <input
              id="slogan"
              onChange={(e) => {
                updateCustomBadge({ text: e.target.value });
              }}
              placeholder="TYPE YOUR TEXT"
              type="text"
              maxLength={17}
              value={customBadge.text}
            />
          </div>
          <div
            className="font-dropdown"
            onClick={() => setIsOpenPopup(!isOpenPopup)}
          >
            <div className="font-dropdown__head">
              {customBadge.font !== "null"
                ? customBadge.font
                : "Select Font Style"}
            </div>
            {isOpenPopup && (
              <div className="font-dropdown__content">
                {props.plateBuilder["font-family"].map((item) => {
                  if (item.slogan) {
                    return (
                      <div
                        className="font-dropdown__item"
                        style={{ "font-family": item.font }}
                        onClick={() => updateCustomBadge({ font: item.font })}
                      >
                        <div className="font-dropdown__name">{item.name}</div>
                      </div>
                    );
                  }
                })}
              </div>
            )}
          </div>
          <p>Badge Text Colour</p>
          <ColorPicker
            color={customBadge.textColor}
            updateColor={onHandlerUpdateColor}
          ></ColorPicker>
        </div>
      )}
      <div className="option-popup__rotation-preview">
        <div className="flex justify-between">
          <div className="option-popup__rotations">
            <p>IMAGE ROTATION</p>
            <div
              className={
                (customBadge.rotate === "false" &&
                  "option-popup__rotation--active") + " option-popup__rotation "
              }
              onClick={() => updateCustomBadge({ rotate: "false" })}
            >
              Landscape
            </div>
            {customBadge.forbiddenRotate === "false" && (
              <div
                className={
                  (customBadge.rotate === "true" &&
                    "option-popup__rotation--active") +
                  " option-popup__rotation "
                }
                onClick={() => updateCustomBadge({ rotate: "true" })}
              >
                Portrait
              </div>
            )}
          </div>
          <div
            className="option-popup__preview flex"
            style={{
              "background-color": customBadge.background,
              color: customBadge.textColor,
              "--icon": customBadge.colorIcon,
            }}
          >
            <div
              className={
                (customBadge.rotate === "true" && "rotate-image") +
                " badge flex flex-col justify-between items-center"
              }
            >
              {customBadge.icon !== "null" &&
                customBadge.colorize === "false" && (
                  <div className="badge-image">
                    <img
                      width="284"
                      height="168"
                      src={require(`../../../../${customBadge.icon}`)}
                      alt="icon"
                    />
                  </div>
                )}
              {customBadge.icon !== "null" &&
                customBadge.colorize === "true" &&
                colorize.map((item) => {
                  if (item.id === customBadge.icon) {
                    return (
                      <div
                        className="badge-image"
                        dangerouslySetInnerHTML={{ __html: item.svg }}
                      ></div>
                    );
                  }
                })}
              <p
                style={{
                  "--font-size": parseFloat(fontSize) > 28 ? "28px" : fontSize,
                  "font-family": customBadge.font,
                }}
              >
                {customBadge.text !== "null" && customBadge.text}
              </p>
            </div>
          </div>
        </div>
        {((activeTab !== tabs2.length && customBadge.colorize === "true") ||
          (activeTab !== tabs.length && customBadge.colorize === "false")) && (
          <div className="option-popup__btn flex justify-center">
            <div
              className=" btn btn--with-border"
              onClick={() => setActiveTab(activeTab + 1)}
            >
              Next
            </div>
          </div>
        )}
      </div>
      {((activeTab === tabs2.length && customBadge.colorize === "true") ||
        (activeTab === tabs.length && customBadge.colorize === "false")) && (
        <div className="option-popup__btn flex justify-center">
          <div className="btn" onClick={buildCustomBadge}>
            Finalise
          </div>
        </div>
      )}
      {props.position === "Left" &&
        props.choosedOptions.hasCustomBadgeRight === "true" && (
          <div
            className="option-popup__btn flex justify-center"
            onClick={() => copyStyling()}
          >
            <div className="btn">Copy Right Badge</div>
          </div>
        )}
      {props.position === "Right" &&
        props.choosedOptions.hasCustomBadgeLeft === "true" && (
          <div
            className="option-popup__btn flex justify-center"
            onClick={() => copyStyling()}
          >
            <div className="btn">Copy Left Badge</div>
          </div>
        )}
    </>
  );
}
